<template>
  <div class="in-box-wrapper">
    <el-card>
      <el-tabs v-model="activeTab">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabs" :key="index"></el-tab-pane>
      </el-tabs>
      <component :is="activeTab" style="margin-top: 10px" />
    </el-card>
  </div>
</template>
<script>
import databaseConfig from './database-config.vue'
export default {
  name: 'admin-tab',
  components: {
    'database-config': databaseConfig
  },
  data () {
    return {
      tabs: [{ label: this.$t('dashboard-bi::admin-config::tab_module'), name: 'database-config', value: '1' }],
      activeTab: 'database-config'
    }
  },

  mounted () {
    if (this.$router.query && this.$router.query.name) {
      this.activeTab = this.$router.query.name
    }
  },
  watch: {
    activeTab (tab) {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped></style>
